import { TeamMemberBio } from './teamMembers.types';

const TEAM_MEMBER_BIOS: readonly TeamMemberBio[] = [
  { name: 'Denniver Reining', use: 1, i18nKey: 'about.team.bios.denniverReining' },
  { name: 'Jakob Strutz', use: 1, i18nKey: 'about.team.bios.jakobStrutz' },
  { name: 'Andreas Sättler', use: 1, i18nKey: 'about.team.bios.andreasSaettler' },
  { name: 'Samuel Haas', use: 1, i18nKey: 'about.team.bios.samuelHaas' },
  { name: 'Holger Gutermuth', use: 1, i18nKey: 'about.team.bios.holgerGutermuth' },
  { name: 'Mathias Bindeus', use: 1, i18nKey: 'about.team.bios.mathiasBindeus' },
  { name: 'Reinhard Sandtner', use: 1, i18nKey: 'about.team.bios.reinhardSandtner' },
  { name: 'Dr. Björn Karst', use: 1, i18nKey: 'about.team.bios.bjoernKarst' },
  { name: 'Klaus Erber', use: 1, i18nKey: 'about.team.bios.klausErber' },
  { name: 'Gil Knimach', use: 1, i18nKey: 'about.team.bios.gilKnimach' },
  { name: 'Anette Clausen', use: 1, i18nKey: 'about.team.bios.anetteClausen' },
  { name: 'Nils Woelke', use: 1, i18nKey: 'about.team.bios.nilsWoelke' },
  { name: 'David Sieben', use: 0, i18nKey: '' },
] as const;

export default TEAM_MEMBER_BIOS;
